import React, { useState } from "react"
import { Redirect} from "react-router-dom"
import { Button } from "reactstrap"

import { useScenario } from "../../contexts/ScenarioContext"

import MDBModal from "./MDBModal"


export default function ScenarioCompleteModal() {
    const [doRedirect, setDoRedirect] = useState(false)

    const {showScenarioComplete, setShowScenarioComplete, saveScenarioToLog} = useScenario()

    const handleSubmit = async (event) => {
        event.preventDefault()
        const {label} = event.target.elements
        await saveScenarioToLog(label.value)
        setShowScenarioComplete(false)
        setDoRedirect(true)
    }

    const handleCancel = () => setShowScenarioComplete(false)

    if (doRedirect) {
        return (
            <Redirect to="/" />
        )
    }
    return (

        <MDBModal
            title="Scenario Complete"
            show={showScenarioComplete}
        >
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <p className="text-danger">
                            WARNING: Submitting the scenario won't allow you to
                            work on it any more.
                        </p>
                        <p>
                            Click 'cancel' if you wish to working
                            on this scenario.
                        </p>
                    </div>
                </div>
                <form onSubmit={handleSubmit} >

                    <div className="row">
                        <label
                            htmlFor="label"
                            className="col-sm-2 col-form-label"
                        >
                            Label
                        </label>
                        <input
                            className="col-sm-10 form-control"
                            type="text"
                            id="label"
                            defaultValue=""
                            placeholder="enter video name (if applicable)"
                        />
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <Button type="submit" color="danger" size="lg"> Submit Scenario Data</Button>
                            <Button color="success" size="lg" onClick={handleCancel}> Cancel </Button>
                        </div>

                    </div>

                </form>
            </div>
        </MDBModal>
    )
}
